import { stegaClean } from "next-sanity"

/**
 * where a post's card should go. a post with an External Link is a "link out" — it has no
 * article page on this site, so its cards point straight at the outside article instead
 */
export function resolvePostLink({
	slug,
	externalUrl,
}: {
	slug?: string | null
	externalUrl?: string | null
}) {
	const external = stegaClean(externalUrl ?? "")

	return external
		? { href: external, openInNewTab: true }
		: { href: `/press/${encodeURIComponent(slug ?? "")}`, openInNewTab: false }
}
